// Replacement for Angular's `textdate` filter + `| date:'MMMM yyyy'`.
// The old data uses inconsistent formats: 'M/D/YYYY', 'YYYY/MM/DD', or
// 'Present' / 'Current'. We pass strings that aren't parseable straight through.

const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

export function formatDate(input: string | undefined, format: 'monthYear' | 'shortMonthYear' = 'monthYear'): string {
  if (!input) return '';
  // Pass through human strings like "Present" / "Current"
  if (/[a-zA-Z]/.test(input) && !/^(\d{1,2}\/\d{1,2}\/\d{4})/.test(input)) {
    return input;
  }

  let y = 0;
  let m = 0;
  let d = 1;

  if (input.includes('/')) {
    const parts = input.split('/').map(Number);
    // Old data has two orderings — distinguish by the first part.
    if (parts[0] > 31) {
      // YYYY/MM/DD
      [y, m, d = 1] = parts;
    } else {
      // M/D/YYYY
      [m, d, y] = parts;
    }
  } else if (input.includes('-')) {
    [y, m, d = 1] = input.split('-').map(Number);
  } else {
    return input;
  }

  if (!y || !m) return input;
  const monthName = MONTHS[m - 1] ?? '';
  if (format === 'shortMonthYear') return `${monthName.slice(0, 3)} ${y}`;
  return `${monthName} ${y}`;
}
